import { render, staticRenderFns } from "./FormularioResultadoView.vue?vue&type=template&id=82b53d6e&"
import script from "./FormularioResultadoView.vue?vue&type=script&lang=ts&"
export * from "./FormularioResultadoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports